import { Stroke, Style } from "ol/style";
import { colorForSpeed } from "./util/colorScale";
import { maxSpeedFromCurvature } from "./curvature";

export function getCaJStyleNormalOrbisSD(feature) {
  return getCaJColorStyle(feature, false, false);
}
export function getCaJStyleClickOrbisSD(feature) {
  return getCaJColorStyle(feature, true, false);
}
export function getCaJStyleHoverOrbisSD(feature) {
  return getCaJColorStyle(feature, false, true);
}

function getCaJColorStyle(feature, click, hover) {
  let width, backgroundColor, backgroundWidth;
  const type = feature.get("type");

  if (type !== "curvature-arc" && type !== "curvature-arc-dummy") {
    return new Style({});
  }

  const curvature = Number(feature.get("curvature_at_junction"));
  const speed = isNaN(curvature) ? 0 : maxSpeedFromCurvature(curvature);
  const [r, g, b] = colorForSpeed(speed);
  const color = `rgb(${r},${g},${b})`;

  if (hover || click) {
    width = 7;
    backgroundWidth = 10;
  } else {
    width = 5;
    backgroundWidth = 9;
  }
  backgroundColor = "white";
  return [
    new Style({
      stroke: new Stroke({
        color: backgroundColor,
        width: backgroundWidth,
      }),
    }),
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
